<template>
  <form
    class="account-change-password card border-0 bg-dark text-light"
    @submit.prevent="submit"
  >
    <div class="card-body">
      <div class="position-relative">
        <button class="btn-back" @click="$emit('back')">
          <i class="fas fa-chevron-left" />
        </button>

        <h3 class="text-center mb-5">Alterar senha</h3>
      </div>

      <form-group
        id="password_old"
        v-model="form.password_old"
        :errors="errors.password_old"
        type="password"
        placeholder="Senha atual"
        label="Senha atual"
      />

      <form-group
        id="password"
        v-model="form.password"
        :errors="errors.password"
        type="password"
        placeholder="Nova senha"
        label="Nova senha"
      />

      <div class="text-center pt-3">
        <button
          type="submit"
          class="btn btn-primary btn-strong px-5 rounded-pill"
          :disabled="loading"
        >
          <loading :show="loading">Salvar</loading>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  data() {
    return {
      loading: false,
      ...formFields(["password_old", "password"])
    };
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("user/updatePassword", this.form)
        .then(() => {
          this.$message.success("Senha alterada com sucesso!");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.account-change-password {
  .btn-back {
    background: transparent;
    border: none;
    color: white;
    font-size: 20px;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
